// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-cZ7t","clinicsSelect":"styles_clinicsSelect__3B65N"};